import { parseIsoTzLess } from '../../date.utils';
import { PraksistypeDto } from '../../api/generated/studiested-generated-api';

export const getDatoInstance = (dato: string | undefined): Date | undefined =>
  dato ? parseIsoTzLess(dato) : undefined;

const praksistypeToKode = ({ kode }: PraksistypeDto): string => kode;

export const praksistyperToKoder = (
  praksistyper?: PraksistypeDto[],
): string[] => praksistyper?.map(praksistypeToKode) || [];
